import React from "react";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";

function Realsql(props) {
  const { realData } = props;
  return (
    <>
      <div className="sql">
        {/* <div className="title">取数Sql</div> */}
        <div className="content">
          <Markdown
            data={{
              think: null,
              thinking: false,
              content: realData,
            }}
          ></Markdown>
        </div>
      </div>
    </>
  );
}

export default Realsql;
